import { StyledComponent } from '@emotion/styled';
import Link from '@mui/material/Link';

import { styled } from 'helpers';

import { LinkProps } from './Link.types';

export const StyledLink: StyledComponent<LinkProps> = styled(Link)`
  font-weight: 800;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  text-decoration: none;
  &.MuiTypography-body1 {
    font-weight: 400;
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  }
  &.Mui-focusVisible {
    outline-color: ${({ theme }) => theme.palette.lightBlue['400']};
    outline-width: 2px;
    outline-offset: 1px;
    box-shadow: 0px 0px 8px rgba(34, 38, 72, 0.16);
  }
  &:hover,
  &:active,
  &:visited {
    color: ${({ theme }) => theme.palette.blue['900']};
    text-decoration: underline;
    .MuiSvgIcon-root {
      fill: ${({ theme }) => theme.palette.blue['900']};
    }
  }
  & .MuiSvgIcon-root {
    fill: ${({ theme }) => theme.palette.blue['800']};
    width: 14px;
    margin: 0 5px 3px 5px;
  }
`;
